<template lang="pug">
  div.wrap-module-lisence-activation
    div.lisence-activation-content
      span lisence-activation

</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-lisence-activation {
  padding-top: $header_height;
  .lisence-activation-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  components: {
  },
  props: {
    // data: {
    //   type: Object,
    //   required: true
    // }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>
